module.exports = __webpack_public_path__ + "img/product-card-06.afb1a9a.webp";